import React from 'react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import ChangePassword from '@/components/user-settings/ChangePassword';
import UserChangeInfo from '@/components/user-settings/UserChangeInfo';
import theme from './UserSettings.module.scss';
import LanguageSettings from '@/components/user-settings/LanguageSettings';
import SimpleFormPage from '@/components/SimpleFormPage/SimpleFormPage';
import LegalSummary from './LegalSummary';
import { useIsBuyer } from '@/utils/hooks';

interface UserSettingsProps {}

const UserSettings: React.FC<UserSettingsProps> = () => {
    const isBuyer = useIsBuyer();
    return (
        <SimpleFormPage cardClassName={isBuyer ? 'card-style-buyer' : undefined} header={t`User settings`}>
            <div className={theme.content}>
                <UserChangeInfo />
                <LanguageSettings />
                <ChangePassword />
                <LegalSummary />
                {/* <ExternalLoginButtons type="link" /> */}
            </div>
        </SimpleFormPage>
    );
};

export default UserSettings;
